import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  sendGiftSuccess,
  sendGiftFailed,
  SEND_GIFT_START,
} from '../../actions/gift'

/**
 * get send gift pools api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const sendGiftApi = (props) => {
  var uri = `/admin/send-gift`
  return api.post(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doSendGift(action) {
  try {
    const response = yield call(sendGiftApi, action?.payload)
      yield put(sendGiftSuccess(response))

      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess(response)
      }
  } catch (error) {
    yield put(sendGiftFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get send gift pools
 */
export default function* watchSendGift() {
  yield takeLatest(SEND_GIFT_START, doSendGift)
}
